export default {
    dashboard: 'Dashboard',
    business: 'Business',
    library: 'Library',
    drafts: 'Posts',
    calendar: 'Calendar',
    planning: 'Planning',
    profile: 'Profile',
    logout: 'Log Out',
};
